var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 0.333252L15 3.66659H12.5L10.8333 0.333252H9.16667L10.8333 3.66659H8.33333L6.66667 0.333252H5L6.66667 3.66659H4.16667L2.5 0.333252H1.66667C0.75 0.333252 0.00833333 1.08325 0.00833333 1.99992L0 11.9999C0 12.9166 0.75 13.6666 1.66667 13.6666H15C15.9167 13.6666 16.6667 12.9166 16.6667 11.9999V0.333252H13.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/Cinema.db712541e30b9375768459b834183365.svg";
export { ForwardRef as ReactComponent };